import { render, staticRenderFns } from "./CitiesManagement.vue?vue&type=template&id=0bf75b70&"
import script from "./CitiesManagement.vue?vue&type=script&lang=js&"
export * from "./CitiesManagement.vue?vue&type=script&lang=js&"
import style0 from "./CitiesManagement.vue?vue&type=style&index=0&id=0bf75b70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports